import { render, staticRenderFns } from "./ConceptChangeDiffDialog.vue?vue&type=template&id=2b467988&scoped=true"
import script from "./ConceptChangeDiffDialog.vue?vue&type=script&lang=js"
export * from "./ConceptChangeDiffDialog.vue?vue&type=script&lang=js"
import style0 from "./addonPayDialog.css?vue&type=style&index=0&id=2b467988&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b467988",
  null
  
)

export default component.exports